/* MBG Premium Motion — 2026-10-08
   Restrained reveal choreography. No mutation observers, no continuous
   scroll handlers, and respects prefers-reduced-motion. */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var sections = document.querySelectorAll('.template-index [data-section-type^="mbg-"]');
  if (!sections.length || !('IntersectionObserver' in window)) {
    sections.forEach(function (el) { el.classList.add('is-mbg-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-mbg-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  sections.forEach(function (el) {
    if (el.classList.contains('mbg-hero')) return;
    el.classList.add('mbg-motion-reveal');
    observer.observe(el);
  });
})();
